import { Severity } from './bulma.js';

/**
 * replacement for bulma notification library
 */
export class Notification {
    private static icons: Record<Severity, string> = {
        danger: 'fa-exclamation-triangle',
        info: 'fa-info-circle',
        warning: 'fa-exclamation-circle',
        success: 'fa-check-circle',
    };

    public static create(
        container: Element,
        message: string,
        severity: Severity,
        append: boolean = false,
        dismissInterval: number = 0,
    ): void {
        const id = this.getRandomId();
        const html = this.getMarkup(message, severity, id);

        if (append) {
            container.innerHTML += html;
        } else {
            container.innerHTML = html;
        }

        if (dismissInterval > 0) {
            setTimeout(
                () => document.getElementById(`#${id}`).remove(),
                dismissInterval,
            );
        }
    }

    /**
     * displays a message to the user in a modal.
     * needs styles from admin.scss (#messages)
     */
    public static createModal(
        message: string,
        severity: Severity,
    ): void {
        const id = this.getRandomId();
        const html = this.getMarkup(message, severity, id, true);

        let container = document.getElementById('messages');

        if (container === null) {
            document.body.innerHTML += '<div id="messages"></div>';
            container = document.getElementById('messages');
        }
        container.classList.remove('empty');

        // show as notification
        container.innerHTML += html;

        // handle container click
        container.addEventListener('click', (e: Event) => {
            if (e.target !== container && (e.target as HTMLElement).tagName !== 'BUTTON') {
                e.stopPropagation();
                return;
            }
            while (container.firstChild) {
                container.firstChild.remove();
            }
            container.classList.add('empty');
        });
    }

    private static getMarkup(
        message: string,
        severity: Severity,
        id: string,
        extended: boolean = false,
    ): string {
        if (!extended) {
            return `
<div class="notification is-${severity}" id="${id}">
    <button class="delete" onclick="this.parentNode.remove()"></button>
    <p>${message}</p>
</div>`;
        }

        return `
<div class="notification is-${severity}" id="${id}">
    <button class="delete" onclick="this.parentNode.remove()"></button>
    <div class="notification-header"><span class="icon"><i class="fas fa-2x ${this.icons[severity]}"></i></span></div>
    <div class="notification-body">${message}</div>
</div>`;
    }

    private static getRandomId(): string {
        return `notif${Math.floor(Math.random() * 10).toString()}`;
    }
}
